<ng-container *ngIf="alertError$ | async as alertMessage">
  <nibtravel-alert [type]="AlertType.INFO">
    <p
      id="alert-info-text"
      class="alert-info-text"
      *transloco="let t; read: 'alert'"
      [innerHTML]="t(alertMessage)"
    ></p>
  </nibtravel-alert>
</ng-container>
